/* @flow */

import * as React from 'react';

import type {EventForTimeline} from '../types';

import {getQuoteLinkText, getTargetEntities, makeTargetEntitiesDisplay} from './helpers';
import {TimelineBanner} from './timeline-banner';

import './timeline-banner.module.css';

type Props = {event: EventForTimeline};

export function TimelineBannerSalesDocumentView(props: Props) {
    const {event} = props;
    const {payload} = event;

    /**
     * We need to include this check, even though we are only passing an event
     * with a payload.__typename of 'SalesDocumentView' because Apollo doesn't generate a specific
     * enough type when using a union type (like the TimelineEventPayload).
     * See this issue for more detail:
     * https://github.com/apollographql/apollo-tooling/issues/1223
     */
    if (payload.__typename === 'SalesDocumentView') {
        const salesDocument = payload.salesDocument;
        const targetEntities = getTargetEntities(salesDocument.lead);

        const targetEntitiesDisplay = makeTargetEntitiesDisplay(
            targetEntities,
            salesDocument.lead.name,
            salesDocument.lead.htmlUrl
        );

        const salesDocumentModalUrl = salesDocument.modalUrl;
        const salesDocumentDisplayNumber = salesDocument.displayNumber;
        const salesDocumentNumberBold = getQuoteLinkText(
            salesDocumentModalUrl,
            salesDocumentDisplayNumber
        );
        const salesDocumentType = payload.salesDocument.__typename.toLowerCase();

        const action = (
            <span>
                <b>{targetEntitiesDisplay}</b> viewed {salesDocumentType} {salesDocumentNumberBold}
            </span>
        );

        return (
            <TimelineBanner
                id={event.id}
                iconVariant={salesDocumentType === 'quote' ? 'quote' : 'invoice'}
                timestamp={event.changeTime}
                actor={null}
                action={action}
                omitActor={true}
            />
        );
    }

    return <></>;
}
